const isolateNumbers = (string: string) => string.replace(/[^0-9]/g, '');
export default isolateNumbers;
